export default __webpack_public_path__ + "static/media/Spark_logo_white.3a213cf8.svg";